import { createAction } from '@reduxjs/toolkit';

export const reset = createAction('RESET');

// Dispatched from shared logout code (baseApiWithReauth.logout()). Each target
// resolves the awaited promise by handling this action in its own middleware —
// mobile additionally awaits LucraSDK.logout(); web has no extra teardown.
export const triggerPlatformLogout = createAction(
  'TRIGGER_PLATFORM_LOGOUT',
  function prepare(onSuccess?: () => void) {
    return {
      payload: {
        onSuccess,
      },
    };
  }
);
